import React from 'react';
import CustomLink from '../CustomLink/CustomLink';

const Footer = () => {
    return (
        <div className='bg-dark text-white p-3'>
        <div className="d-md-flex justify-content-md-around align-items-md-center         pb-3">
            <CustomLink className="px-3" to="/">Home</CustomLink>
      <CustomLink className="px-3" to="/edit1">Offer</CustomLink>
      <CustomLink className="px-3" to="/edit2">Privacy and Policy</CustomLink>
      <CustomLink className="px-3" to="/about">About Me</CustomLink>
      <CustomLink className="px-3" to="/edit4">Contact Me</CustomLink>
        </div>
           

            <div className="d-flex justify-content-center align-items-end pb-3">
               <p className="text-white">
                   © 2022, All rights reserved by <a className='text-decoration-none text-success' href='https://dhananjoychandradas.blogspot.com/' target="_blank">Dhananjoy Chandra Das</a> 
                </p>
       </div>
        </div>
    );
};

export default Footer;